// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2BZbk","consentsList":"PatientConsents_consentsList__3qdpS","consentsListEmpty":"PatientConsents_consentsListEmpty__1mF72"};